import { render, staticRenderFns } from "./schedulingTaskDetails.vue?vue&type=template&id=2336395c&scoped=true"
import script from "./schedulingTaskDetails.vue?vue&type=script&lang=js"
export * from "./schedulingTaskDetails.vue?vue&type=script&lang=js"
import style0 from "./schedulingTaskDetails.vue?vue&type=style&index=0&id=2336395c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2336395c",
  null
  
)

export default component.exports